module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_9_5.e7282997.png";